//Description: This file contains a function that manages tabs in a tab control div.
//-----------------------------------------------------------------------------------------------
//The function stores the id of the selected tab in localStorage and activates the corresponding tab pane.
//the structure of the tab control div should be as follows:
//<div id="company-tab-control">
//    <ul class="nav nav-tabs">
//        <li class="nav-item">
//            <a class="nav-link" id="tab1" data-toggle="tab" href="#tab-pane1">Tab 1</a>
//        </li>
//        <li class="nav-item">
//            <a class="nav-link" id="tab2" data-toggle="tab" href="#tab-pane2">Tab 2</a>
// etc
//    </ul>
//    <div class="tab-content">
//        <div class="tab-pane" id="tab-pane1">Tab 1 content</div>
// etc..
//    </div>
//</div>
//The function should be called in the app.js file as follows:
//window.TabsManager.manageTabs("company-tab-control");
//tab item and names are just examples, they should be replaced with actual names


function getForcedTabIdFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const tab = urlParams.get("tab");

    if (tab === "invoice") {
        return "nav-link2";
    }
    if (tab === "shipping" || tab === "addresses") {
        return "nav-link3";
    }
    if (tab === "account" || tab === "user") {
        return "nav-link1";
    }
    if (urlParams.get("show_add_address_toast") === "1") {
        return "nav-link3";
    }

    return null;
}

function activateTab(tabControlId, tabLinkId) {
    const selectedTab = document.querySelector("#" + tabLinkId);
    if (!selectedTab) {
        return;
    }

    document.querySelectorAll("#" + tabControlId + " .nav-link").forEach((link) => {
        link.classList.remove("active");
    });
    selectedTab.classList.add("active");

    const selectedTabHref = selectedTab.getAttribute("href");
    document.querySelectorAll("#" + tabControlId + " .tab-pane").forEach((tabPane) => {
        tabPane.classList.remove("active");
    });

    const selectedTabPane = document.querySelector(selectedTabHref);
    if (selectedTabPane) {
        selectedTabPane.classList.add("active");
    }
}

module.exports.manageTabs = function manageTabs(tab_control_id) {
    document.addEventListener("DOMContentLoaded", (event) => {

        // ---------------------- tabs management ----------------------
        // Get all tab links with company-tab-control div id
        let tabs = document.querySelectorAll("#" + tab_control_id + " .nav-link");

        // Add click event listener to each tab link
        tabs.forEach(tab => {
            tab.addEventListener("click", function() {
                // Store the id of the clicked tab link in localStorage
                localStorage.setItem("selectedTab", this.id);
                console.log("selcted tab set to:" + localStorage.getItem("selectedTab"));
            });
        });

        const forcedTabId = getForcedTabIdFromUrl();
        let selectedTabId = forcedTabId || localStorage.getItem("selectedTab");

        if (forcedTabId) {
            localStorage.setItem("selectedTab", forcedTabId);
        }

        // If there's an id stored in localStorage, activate the corresponding tab
        if (selectedTabId) {
            activateTab(tab_control_id, selectedTabId);
        } else {
            // If there's no id stored in localStorage, activate the first tab
            tabs[0].classList.add("active");

            //find first tab within div named company-tab-control
            let navLinks = document.querySelectorAll("#" + tab_control_id + " .nav-link");
            let ids = Array.from(navLinks).map(link => link.id);
            document.querySelector("#" + ids[0]).classList.add("active");
            let hrefs = Array.from(navLinks).map(link => link.getAttribute("href"));
            document.querySelector(hrefs[0]).classList.add("active");
        }

    });
};
